import React from 'react';
import {connect} from 'react-redux';

import * as StakeStatuses from 'constants/StakeStatus';

import BetRate from './BetRate.jsx';
import BetStatus from './BetStatus.jsx';
import BetTitle from './BetTitle.jsx';
import BetOverallInfo from './BetOverallInfo.jsx';

import {balance as getBalanceAction} from 'actions/balance/balanceAction';
import {getFreebet as getFreebetAction} from 'actions/creators/Freebet';

function betUnderConfirmation(betStatus) {
    return betStatus === BetStatus.CONFIRM_AWAIT || betStatus === BetStatus.IN_DELAY ||
           betStatus === BetStatus.STAKE_REQUEST;
}

class Bet extends React.Component {
    static propTypes = {
        user: React.PropTypes.object.isRequired,
        id: React.PropTypes.string.isRequired,
        bet: React.PropTypes.object.isRequired,
        getBalanceAction: React.PropTypes.func.isRequired,
        getFreebetAction: React.PropTypes.func.isRequired
    };

    componentWillReceiveProps(nextProps) {
        const newBetStatus = nextProps.bet.get('betStatus');
        const oldBetStatus = this.props.bet.get('betStatus');

        if (newBetStatus === oldBetStatus ||
            (betUnderConfirmation(newBetStatus) && betUnderConfirmation(oldBetStatus))) {
            return;
        }

        if (oldBetStatus !== BetStatus.CONFIRMED && newBetStatus === BetStatus.CONFIRMED) {
            window.setTimeout(() => {
                this.props.getBalanceAction({accountId: this.props.user.get('accountId')});
                this.props.getFreebetAction();
            },0);
        }
    }

    static renderBetRate(rateId, id) {
        return (
            <BetRate key={rateId} id={id} rateId={rateId}/>
        );
    }

    render() {
        const id = this.props.id;
        const bet = this.props.bet;
        
        if(!bet) {
            return null
        }

        const betSlips = bet.get('betSlips').valueSeq().toList();
        const stakeStatus = bet.get('stakeStatus');

        let className = 'bet-item';
        if (stakeStatus === StakeStatuses.WON) {
            className += ' win';
        }

        return (
            <div className={className}>
                <BetTitle id={id}/>
                <ul className="bet-history-list">
                    {betSlips.map(bs => Bet.renderBetRate(bs.getIn(['rate', 'id']), id))}
                </ul>
                <BetOverallInfo id={id}/>
                <BetStatus id={id}/>
            </div>
        );
    }
}

function select(state, props) {
    const user = state.auth.get('user');
    const id = props.id;
    const bet = state.application.getIn(['betHistory', id]);
    const languageId = state.application.get('languageId');

    return {
        user,
        id,
        bet,
        languageId
    };
}

export default connect(select, {getBalanceAction, getFreebetAction})(Bet);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/Bet.jsx